import { createAction, props } from '@ngrx/store';
import { ICommandContext, IDockingContext } from '../../../../model/docking';
import { ILocationContext } from '../../../../model/location-context';

export const requestDockingContext = createAction(
    '[Docking] Request Docking Context',
    props<{ locationContext: ILocationContext }>()
);
export const loadDockingContext = createAction(
    '[Docking Effects] Load DockingContext',
    props<{ dockingContext: IDockingContext }>()
);
export const triggerDockingCommand = createAction(
    '[Docking] Trigger Docking Command',
    props<{ commandContext: ICommandContext; operator: string }>()
);
export const setUserMonitoring = createAction('[Docking] Set User Monitoring', props<{ userMonitoring: boolean }>());
